// extracted by mini-css-extract-plugin
module.exports = {"productInfoForm":"ProductInfo_productInfoForm__1e6of","productInfoFormItem":"ProductInfo_productInfoFormItem__3r5Cz","selectDropdown":"ProductInfo_selectDropdown__DODZC"};